import { LabelTypes } from "./LabelTypes";

export type RadioValue = string | number;

export const RadioNA = "N/A";

export interface RadioLabelValue extends LabelTypes {
  value: RadioValue;
}
